import { Container, Button,Form, Alert, Modal} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper} from "../ContentStyles";
import { FaUserPlus } from 'react-icons/fa';
import React, {useMemo, useState, useEffect } from 'react';
import {useNavigate} from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, {Loading, SpinnerX, CallAPI, IsLoggedIn} from '../../services/useBackend_v2';
import { FaRegCheckCircle, FaCreditCard } from 'react-icons/fa';
import { Branding, SplitoutLocalDateFromISO } from '../../services/misc';

var typingTimeout = null;

export default function MyComponent() {
    const {loading, data, Refresh, XCall, Check, initReady, resultVisible, resultText, resultVariant } =  useBackend('/api/admin/customers');
    const { loading: registerDataLoading, data: registerData } = useBackend(process.env.PUBLIC_URL + '/api/admin/Register');

    const defaultValues              = { Guid:null, Name:"", SSN:"", Banned:false, isAdmin:false, isAllIn:false, CustomerAge:0, DiscountPercentage:0, Balance:0, eMail:"", initCompleted:false, StandardShopId:0 };
    const [editData, setEditData]    = useState(defaultValues);
    const [editCustomerModalshow,  setEditCustomerModalshow] = useState(false);

    const navigate = useNavigate();

    const showUserClick = (event, rowData)  =>  {        
        event.preventDefault();
        setEditData(rowData.original);

        setEditCustomerModalshow(!editCustomerModalshow);    
    }

    async function closeAndRefresh() {
        setEditData(defaultValues);
        setEditCustomerModalshow(false);
        Refresh();
    }    
    
    const columns = useMemo(() => [
        { size: 20, accessorKey: 'SSN',   header: 'Personnummer', enableColumnActions: false },
        { size: 20, accessorKey: 'Name',  header: 'Namn' },
        { size: 20, accessorKey: 'eMail',  header: 'Email' },

        {
            size: 20, header: 'Spärrad', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: false,
            Cell: ({ row }) => (<>{row.original.Banned && <FaRegCheckCircle />}</>),
        },
        
        {
            size: 20, header: 'Priokund', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: false,
            Cell: ({ row }) => (<>{row.original.isPrio && <FaRegCheckCircle />}</>),
        }
      ]
    );       

    if (initReady && !registerDataLoading) {
        
        return (
            <ContentWrapper>
                <ModalCustomerEdit modalshow={editCustomerModalshow} onHide={closeAndRefresh} CustomerGuid={editData.Guid} registerData={registerData} ></ModalCustomerEdit>
                <Container>
                    <Sida>
                        <MaterialReactTable columns={columns} data={data.Customers}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, labelRowsPerPage:"Rader"}}
                            initialState={{ pagination: { pageSize: 25 }, density: 'compact', columnVisibility: { Banned: false, eMail: false },  }}
                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }}
                            muiTableBodyRowProps={({ row }) => ({
                            onClick: (event) => { showUserClick(event, row); }, sx: { cursor: 'pointer' } })}

                            renderTopToolbarCustomActions= {() => ( <div style={{width:"100%"}}>
                                <div style={{float:"left"}}> <Rubrik>Kunder</Rubrik> </div>
                                <div style={{float:"right"}}><Button onClick={() => { setEditData(defaultValues); setEditCustomerModalshow(!editCustomerModalshow) }} variant="outlined" title='Lägg till kund'><FaUserPlus color="gray" /></Button></div>
                            </div>)}
                        />
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}

export function ModalCustomerEdit(props) {
    const { loading, data, Refresh, resultVariant, resultVisible, resultText, resultSuccess, ReInit, Update, XCall, GUIDx } = useBackend('');
    const defaultValues              = { Guid:null, Name:"", SSN:"", Banned:false, isAdmin:false, isAllIn:false, CustomerAge:0, DiscountPercentage:0, Balance:0, eMail:"", initCompleted:false, StandardShopId:0 };
    const [editData, setEditData]    = useState(defaultValues);
    const [hideBalanceController,  setHideBalanceController] = useState("hidden");
        var { loggedIn, isSuperUser, userName, isSuperUser } = IsLoggedIn();

    const navigate = useNavigate();

    async function closeForm() {
        setEditData(defaultValues); 
        setHideBalanceController(true);
        props.onHide();        
    }
    
    async function showForm() {
        if (props.CustomerGuid != null) {
            let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/admin/customers/' + props.CustomerGuid, "GET");        
            setEditData(jsondata.Customer);
        } else {
            setEditData(defaultValues);
        }
        //setEditData(props.editCustomerData);        
    }

    async function handleChange(event){
        const DataForm = document.getElementById('DataForm');
        const formData = new FormData(DataForm);
        const formDataObj = Object.fromEntries(formData.entries());

        let newBalance = Number(editData.Balance) + Number(formDataObj.BalanceAddx);

        const newDataObj = { 
            Guid: editData.Guid, 
            Name: formDataObj.Name, 
            SSN: formDataObj.SSN, 
            Banned: formData.has('Banned') ? true : false, 
            isAdmin: formData.has('isAdmin') ? true : false, 
            isPrio: formData.has('isPrio') ? true : false,
            StandardShopId: formDataObj.StandardShopId,
            PrioDate: new Date(),
            BalanceAdd: formDataObj.BalanceAddx,
            Balance: newBalance,
            CustomerAge: editData.CustomerAge,
            eMail: formDataObj.eMail,
            initCompleted: true,
            DiscountPercentage:  parseInt(formDataObj.DiscountPercentage)
        };
        setEditData(newDataObj);
    }

    useEffect(() => {
        clearTimeout(typingTimeout);
        if (editData.Guid != null && editData.initCompleted) typingTimeout = setTimeout(handleSave, 475);
    }, [editData])

    async function handleSave(){
        let { errorsException } = await XCall('/api/admin/customers/'+editData.Guid, "PATCH", 3000, editData);
        setHideBalanceController(true);
        const BalanceAdd = document.getElementById('BalanceAddx');
        BalanceAdd.value = 0;
        if (!errorsException) Refresh();
    }

    async function AddUser(){
        let { errorsException } = await XCall('/api/admin/customers', "POST", 3000, editData);
        setHideBalanceController(true);

        if (!errorsException) {
            setTimeout(() => {
                closeForm();
            }, 2000);
            Refresh();
        }
    }  

    function getOptions(object) {
        return object.map((key) => {
            return <option key={key.Id} value={key.Id}>{key.Name}</option>;
        });
    }

    return (

                <Modal show={props.modalshow} onHide={() => closeForm()} onShow={() => showForm()}>
                    <Modal.Header closeButton>
                        <Modal.Title>{editData.Name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form id="DataForm">
                            <Form.Group className="mb-3" >
                                <Form.Label>Namn <small>{editData.SSN}</small></Form.Label>
                                <Form.Control type="text" name="Name" placeholder="Namn" defaultValue={editData.Name} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="text" name="eMail" placeholder="Email" defaultValue={editData.eMail} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label>Personnummer</Form.Label>
                                <Form.Control type="text" name="SSN" placeholder="Ex 19121212xxxx" disabled={ editData.Guid == null ? false : true } value={editData.SSN} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label>Standardbutik</Form.Label>
                                <Form.Select name="StandardShopId" value={editData.StandardShopId} onChange={handleChange}>
                                    <option value={0}>------</option>
                                    {getOptions(props.registerData.shops)}
                                </Form.Select>
                            </Form.Group>                            

                            <Form.Group className="mb-3" >
                                <Form.Label>Saldo (Kr)</Form.Label>                                
                                <div className="d-flex">
                                    <Form.Control type="text" name="Balance" id="Balance" placeholder="0" value={editData.Balance} disabled />&nbsp;
                                    <Button className="QmeButtonSmall" variant="primary" type="button" onClick={() => setHideBalanceController(!hideBalanceController)} style={{ whiteSpace: "nowrap", minWidth: "auto", backgroundColor: Branding().ButtonColor }}><FaCreditCard /></Button>
                                </div>
                             
                            </Form.Group>     

                            <Form.Group className="mb-3" hidden={hideBalanceController}>
                                <div className="d-flex">
                                    <Form.Control type="text" name="BalanceAddx" id="BalanceAddx" placeholder="0" defaultValue={0} />&nbsp;
                                    <Button className="QmeButton" variant="primary" type="button" onClick={handleChange} style={{ whiteSpace: "nowrap", minWidth: "auto", backgroundColor: Branding().ButtonColor }}>Lägg till</Button>
                                </div>
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label>Rabatt (%)</Form.Label>
                                <Form.Control type="number" name="DiscountPercentage" id="DiscountPercentage" placeholder="Rabatt (%)" value={editData.DiscountPercentage} disabled={ isSuperUser ? false : true }  onChange={handleChange}/>
                            </Form.Group>                                                     

                            <Form.Group className="mb-3" >
                                <Form.Label>Ålder</Form.Label>
                                <Form.Control type="text" name="age" placeholder="Ålder" value={editData.CustomerAge} disabled />
                            </Form.Group>
                        
                            <Form.Group className="mb-3" >
                                <Form.Check type="switch" name="Banned" id="Banned" label="Spärra användare" checked={editData.Banned} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Check type="switch" name="isAdmin" id="isAdmin" label="Admin" checked={editData.isAdmin} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Check type="switch" name="isPrio" id="isPrio" label={editData.isPrio ? <>Priokund (All-In)  { SplitoutLocalDateFromISO(editData.Priodate) }</>: <>Priokund (All-In)</>} checked={editData.isPrio} onChange={handleChange} />
                            </Form.Group>
                        </Form>

                        <Form.Group className="mb-3" hidden={!loading}>
                            <SpinnerX />
                        </Form.Group>

                        <Form.Group className="mb-3" hidden={!resultVisible}>
                            <Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        {editData.Guid == null ? <>
                            <Button variant="info" onClick={() => AddUser()}>Lägg till</Button>
                        </> : <>
                            <Button variant="" onClick={() => navigate("/customer/"+editData.Guid)}>Historik</Button>
                            <Button variant="danger" onClick={() => { closeForm(); }}>Close</Button>                        
                        </>}
                    </Modal.Footer>
                </Modal>        
    );
}